'use strict';
import React, { PureComponent } from 'react';
import TablaHeader from './Tabla/TablaHeader'
import TablaBody from './Tabla/TablaBody'

class Tabla extends PureComponent {

    constructor(props) {
        super(props);

    }

    render() {
        const { ingresoCobranza, confirmarCobranza, denegarCobranza, editar, eliminarCobranza, cobranzas, expandirRow, rowSeleccionada, permisosUsuario } = this.props;

        return (
            <div className="row top-separator-xs">

                <div className="col-xs-12">

                    <h3>Cobranzas Registradas Desde el Último Cierre</h3>

                    <table className="table clickeable-row-table">
                        <TablaHeader />
                        <TablaBody ingresoCobranza={ingresoCobranza}
                            cobranzas={cobranzas}
                            expandirRow={expandirRow}
                            rowSeleccionada={rowSeleccionada}
                            confirmarCobranza={confirmarCobranza}
                            denegarCobranza={denegarCobranza}
                            editar={editar}
                            eliminarCobranza={eliminarCobranza}
							permisosUsuario={permisosUsuario}
							/>
                    </table>

                </div>
            </div>
        )

    }
}

export default Tabla;